import { i18n } from "@/utils/i18n";
import { TableCell, TableFooter, TableRow, Typography } from "@mui/material";
import React from "react";

interface Props {
    endAmount: number;
}

const Footer: React.FC<Props> = ({ endAmount }) => {
    return (
        <TableFooter>
            <TableRow>
                <TableCell colSpan={5} sx={{ borderBottom: "none", borderTop: "2px solid #ccc" }} />
                <TableCell align="right" sx={{ borderBottom: "none", borderTop: "2px solid #ccc" }}>
                    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                        {i18n.t("sumD")} {endAmount}
                    </Typography>
                </TableCell>
                <TableCell sx={{ borderBottom: "none", borderTop: "2px solid #ccc" }} />
            </TableRow>
        </TableFooter>
    );
};

export default Footer;
